module.exports = __webpack_public_path__ + "494cd07c/img/file-icon.c085e21e.svg";